import { SERVER_API_URL, SERVER_DOMAIN } from "../constants/constants";
import axios from "axios";

const getAllTransaction = async (page, perPage) => {
  const getToken = localStorage.getItem("token");
  // console.log(page,perPage,getToken)
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/AllTransaction/getTransaction`;
  const result = await axios.get(url, config);
  return result;
};
const getfailedTransaction = async (page, perPage) => {
  const getToken = localStorage.getItem("token");
  // console.log(page,perPage,getToken)
  const config = {
    headers: { Authorization: `Bearer ${getToken}` },
  };
  const url = `${SERVER_API_URL}/admin/AllTransaction/getfailedTransaction`;
  const result = await axios.get(url, config);
  return result;
};


export { getAllTransaction,getfailedTransaction};
